import definition from 'payment_definition';
import rms_definition from 'rms_definition';
import file_definition from 'file_definition';
import market_definition from 'market_definition';
import invoice_definition from 'invoice_definition';
import asset_definition from 'asset_definition';
global.app.sdk.payment = global.app.create_sdk(definition, true);
global.app.sdk.rms = global.app.create_sdk(rms_definition, true);
global.app.sdk.file = global.app.create_sdk(file_definition, true);
global.app.sdk.market = global.app.create_sdk(market_definition, true);
global.app.sdk.invoice = global.app.create_sdk(invoice_definition, true);
global.app.sdk.asset = global.app.create_sdk(asset_definition, true);
/*if (global.app.name === 'payment_ui') {}
 */
